import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { LeaderApproval } from 'containers/forms/dashboard'
import { MaterialModal } from 'components/layout'

export default class LeaderApprovalModal extends Component {
  static propTypes = {
    colorClass: PropTypes.string,
    modalId: PropTypes.string
  }

  render() {
    const { colorClass, modalId } = this.props

    return (
      <MaterialModal.Body id={modalId} colorClass={colorClass} narrow noHeader>
        <MaterialModal.Content noFooter noHeader>
          <LeaderApproval {...this.props} fullWidth />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
